import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPie = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="var(--dataviz-color-sequential-blue-scale05)"
      d="M6.627 9.566a10.876 10.876 0 0 0 11.091 15.257l-1.163-10.814z"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale03)"
      d="M17.605 24.828a10.875 10.875 0 0 0 7.991-16.864l-9.045 6.04z"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale06)"
      d="M10.64 4.883a10.88 10.88 0 0 0-4.203 5.122l10.109 4.011z"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale02)"
      d="M18.128 3.255a10.88 10.88 0 0 0-7.914 1.912l6.326 8.848.001-.011 10.177-3.818a10.88 10.88 0 0 0-8.589-6.938z"
    />
  </svg>
);
export default SvgPie;
